import type React from 'react';

import { Button, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';
import { Link } from '@change-corgi/core-react/router';

type Props = {
	onClick: () => void;
};

export const SapCta: React.FC<Props> = ({ onClick }) => {
	return (
		<Link
			to="/start-a-petition/intro?source_location=petition_show"
			onClick={onClick}
			className="block text-inherit no-underline"
			aria-labelledby="sap_cta_label"
			aria-describedby="sap_cta_desc"
		>
			<div className="border-stroke-weaker flex flex-col items-center rounded-md border p-4 md:flex-row">
				<div className="basis-[60%]">
					<Text as="div" variant="heading" size="small" fontWeight="bold" id="sap_cta_label" className="mb-4">
						<Translate value="fe.pages.petition_show.sap.start_your_own" />
					</Text>
					<Text as="div" id="sap_cta_desc">
						<Translate value="fe.pages.petition_show.sap.cta_description" />
					</Text>
				</div>
				<div className="w-full basis-[40%]">
					{/* disable tabindex because is not a functioning button - the whole card is a link */}
					<Button variant="secondary" tabIndex={-1} className="w-full">
						<Translate value="fe.pages.home.start_a_petition" />
					</Button>
				</div>
			</div>
		</Link>
	);
};
